import { PaymentMethodsResponse } from '../../types';
import { eventsRequest } from '../../utils/eventsRequest';

const getPaymentMethods = async (): Promise<PaymentMethodsResponse | false> => {
    try {
        const response = await eventsRequest(`/payment/methods`, 'get');
        
        if (response.status === 200) {    
            return response.data as PaymentMethodsResponse;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export default getPaymentMethods;
